// extracted by mini-css-extract-plugin
export default {"container":"UJ-z","dimension":"VJ-z","dimensionLabels":"WJ-z"};